module.exports = __webpack_public_path__ + "img/shibie.e0043169.jpeg";